/**
 * 父子窗口的通讯
 *
 * @author lianghua.fu
 * @date 2020-11-17 11:42:24
 */
$.module('MM.messenger', function () {
  var Messenger = (function () {
    // 消息前缀, 建议使用自己的项目名, 避免多项目之间的冲突
    // !注意 消息前缀应使用字符串类型
    var prefix = '[PROJECT_NAME]',
      supportPostMessage = 'postMessage' in window;

    // Target 类, 消息对象
    function Target(target, name, prefix) {
      var errMsg = '';
      if (arguments.length < 2) {
        errMsg = 'target error - target and name are both required';
      } else if (typeof target != 'object') {
        errMsg = 'target error - target itself must be window object';
      } else if (typeof name != 'string') {
        errMsg = 'target error - target name must be string type';
      }
      if (errMsg) {
        throw new Error(errMsg);
      }
      this.target = target;
      this.name = name;
      this.prefix = prefix;
    }

    // 往 target 发送消息, 出于安全考虑, 发送消息会带上前缀
    if (supportPostMessage) {
      // IE8+ 以及现代浏览器支持
      Target.prototype.send = function (msg) {
        this.target.postMessage(this.prefix + '|' + this.name + '__Messenger__' + msg, '*');
      };
    } else {
      // 兼容IE 6/7
      Target.prototype.send = function (msg) {
        var targetFunc = window.navigator[this.prefix + this.name];
        if (typeof targetFunc == 'function') {
          targetFunc(this.prefix + msg, window);
        } else {
          throw new Error('target callback function is not defined');
        }
      };
    }

    // 信使类
    // 创建Messenger实例时指定, 必须指定Messenger的名字, (可选)指定项目名, 以避免Mashup类应用中的冲突
    // !注意: 父子页面中projectName必须保持一致, 否则无法匹配
    function Messenger(messengerName, projectName) {
      this.targets = {};
      this.name = messengerName;
      this.listenFunc = [];
      this.prefix = projectName || prefix;
      this.initListen();
    }

    // 添加一个消息对象
    Messenger.prototype.addTarget = function (target, name) {
      var targetObj = new Target(target, name, this.prefix);
      this.targets[name] = targetObj;
    };

    // 删除一个消息对象
    Messenger.prototype.removeTarget = function (name) {
      this.targets[name] = null;
      delete this.targets[name];
    };

    // 初始化消息监听
    Messenger.prototype.initListen = function () {
      var self = this;
      var generalCallback = function (msg) {
        if (!msg) {
          return;
        }

        if (typeof msg == 'object' && msg.data) {
          msg = msg.data;
        }

        if (msg.toString().indexOf('__Messenger__') === -1) {
          return;
        }

        var msgPairs = msg.split('__Messenger__');
        var fn = msgPairs[1];
        var pairs = msgPairs[0].split('|');
        var prefix = pairs[0];
        var name = pairs[1];

        for (var i = 0; i < self.listenFunc.length; i++) {
          if (prefix + name === self.prefix + self.name) {
            self.listenFunc[i](fn);
          }
        }
      };

      if (supportPostMessage) {
        if ('addEventListener' in document) {
          window.addEventListener('message', generalCallback, false);
        } else if ('attachEvent' in document) {
          window.attachEvent('onmessage', generalCallback);
        }
      } else {
        // 兼容IE 6/7
        window.navigator[this.prefix + this.name] = generalCallback;
      }
    };

    // 监听消息
    Messenger.prototype.listen = function (callback) {
      var i = 0;
      var len = this.listenFunc.length;
      var cbIsExist = false;
      for (; i < len; i++) {
        if (this.listenFunc[i] == callback) {
          cbIsExist = true;
          break;
        }
      }
      if (!cbIsExist) {
        this.listenFunc.push(callback);
      }
    };
    // 注销监听
    Messenger.prototype.clear = function () {
      this.listenFunc = [];
    };
    // 广播消息
    Messenger.prototype.send = function (msg) {
      var targets = this.targets,
        target;
      for (target in targets) {
        if (targets.hasOwnProperty(target)) {
          targets[target].send(msg);
        }
      }
    };

    return Messenger;
  })();

  var projectName = 'memezhibo';
  var messengerName = 'parent';

  var cacheMessenger = {};
  var currentMessenger = null;
  var targetsClose = {};

  var actions = {
    // 跳转到支付
    showPayPopup: function (data) {
      MM.common.redirectPay();
    },
    redirectPage: function (data) {
      window.open(data.url);
    },
    // 刷新背包
    refreshBag: function () {
      MM.user.getExtraUserInfo();
      MM.live.bag.refresh();
    },
    // 刷新用户信息，包含顶部的余额显示
    refreshUserInfo: function () {
      MM.user.getExtraUserInfo();
    },
    redirectLogin: function () {
      MM.user.popupLogin();
    },
    closeTarget: function (data) {
      var targetName = data.targetName;
      targetsClose[targetName] && targetsClose[targetName]();
      delete targetsClose[targetName];
    },
    /**
     *
     * @param msg
     * {
     *     action,  对应的操作
     *     from,    来自哪个窗口
     *     callbackKey,
     *     data     参数
     * }
     */
    callParent: function (msg) {
      var parentActions = {
        getToken: function (data) {
          return MM.user.getToken();
        },
        isLogin: function (data) {
          return MM.user.isLogin();
        },
        getRoomId: function (data) {
          return MM.live.room.getRoomId();
        },
        getRoomInfo: function (data) {
          return MM.live.room.getRoomInfo();
        },
        getParentInfo: function () {
          return {
            clientType: 'PC',
          };
        },
      };

      var action = parentActions[msg.action];
      var target = currentMessenger.targets[msg.from] || currentMessenger;

      target.send(
        JSON.stringify({
          action: 'callback',
          callbackKey: msg.callbackKey,
          data: action(msg.data),
        }),
      );
    },
  };

  function init() {
    currentMessenger = new Messenger(messengerName, projectName);
    currentMessenger.listen(function (msg) {
      try {
        var msgObj = JSON.parse(msg);
        MM.core.debug('[messenger]action:', msgObj.action, 'data:', msgObj.data);
        actions[msgObj.action] && actions[msgObj.action](msgObj.data);
      } catch (e) {
        console.error('[messenger]-[' + messengerName + '] error', e);
        throw new Error('[messenger]-[' + messengerName + '] error');
      }
    });
  }

  /**
   * 添加内嵌 iframe
   * @param target      子窗口对象
   * @param targetName  子窗口的通信名
   * @param closeTarget 用来子窗口关闭自己的
   */
  function addTarget(target, targetName, closeTarget) {
    currentMessenger.addTarget(target, targetName);
    targetsClose[targetName] = closeTarget;
  }

  function removeTarget(targetName) {
    currentMessenger.removeTarget(targetName);
  }

  function send(msg) {
    currentMessenger.send(JSON.stringify(msg));
  }

  function refreshToken(token) {
    send({
      action: 'refreshToken',
      data: token,
    });
  }

  if (window['APP_TYPE'] !== 'PC_V2') {
    init();
  }

  return {
    init: init,
    addTarget: addTarget,
    removeTarget: removeTarget,
    send: send,
    refreshToken: refreshToken,
  };
});
